const UPDATES = [
  { date: '2026.07.31', title: '暑期档专题重磅上线', desc: '2026年暑期热门电影全集专题页面上线，一站式浏览今夏所有好片。' },
  { date: '2026.07.30', title: '流浪地球3高清版入库', desc: '年度科幻巨制流浪地球3高清版本正式入库，支持1080P不缓冲流畅播放。' },
  { date: '2026.07.29', title: '经典电影修复计划启动', desc: '启动经典老片数字化修复工程，首批50部影片已完成高清化处理并上架。' },
  { date: '2026.07.28', title: '动画电影专区扩容', desc: '动画电影片库新增大鱼海棠、深海等国产动画佳作及海外获奖动画合集。' },
  { date: '2026.07.27', title: '播放体验全面优化', desc: '升级全球CDN加速节点，移动端加载速度提升40%，弱网环境也能流畅播放。' },
  { date: '2026.07.26', title: '悬疑推理专题上线', desc: '悬疑烧脑电影专题合集上线，精选国内外高分悬疑、惊悚、推理类影片120部。' },
  { date: '2026.07.25', title: '封神第二部全网首发', desc: '国产奇幻史诗封神第二部在平台完成全网首发，首日播放量突破500万次。' },
  { date: '2026.07.24', title: '片库总量突破五万部', desc: '6080影视片库正式突破50000部大关，覆盖全球120个国家和地区的电影资源。' },
  { date: '2026.07.23', title: '移动端适配优化完成', desc: '全面优化手机和平板端观影体验，自适应不同屏幕尺寸，触控操作更便捷。' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            6080影视平台最新更新与重要公告
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-0 bottom-0 w-0.5 bg-background-300"></div>

          <div className="space-y-6">
            {UPDATES.map((item, i) => (
              <div key={i} className="relative flex gap-4 md:gap-6 pl-10 md:pl-12">
                <div className="absolute left-[15px] md:left-[19px] w-2.5 h-2.5 rounded-full bg-accent-500 ring-4 ring-background-100 mt-1.5"></div>
                <div className="flex-1 min-w-0">
                  <span className="text-xs font-medium text-accent-700">{item.date}</span>
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 mt-0.5 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}